<template>
    <div class="board_graph_list wordcloud_graph">
        <template v-if="!props.loading">
            <Chart style="min-height: 400px" v-if="chartData" :defaultLayout="chartLayout" :data="chartData"></Chart>
            <NoResult v-else></NoResult>
        </template>
        <Spinner v-else></Spinner>
    </div>
</template>

<script lang="ts" config>
    import {
        Chart,
        numberFormat,
        reactive,
        LayoutOption,
        Spinner,
        ref,
        ChartData,
        onMounted,
        chartDateFormat2,
        NoResult,
        setCoOccurrenceData,
        watch,
    } from "@/BaseComponent";
    export default {
        props: ["loading", "links"],
        components: {
            Chart,
            Spinner,
            NoResult,
        },
        setup(props: any) {
            const chartData = ref<ChartData | null>();
            const chartLayout = reactive({
                type: "coOccurrence",
                xAxisKey: "",
            } as LayoutOption);

            onMounted(() => {
                if (props.links.length > 0) setData(props.links);
            });

            watch(
                () => props.links,
                (newList) => setData(newList),
                { deep: true },
            );

            const setData = (links: any) => {
                const nodeMap = new Map();

                props.links.forEach((item: any) => {
                    const { searchKeyword, keyword, cnt } = item;

                    if (!nodeMap.has(searchKeyword)) {
                        nodeMap.set(searchKeyword, {
                            name: searchKeyword,
                            value: 0,
                            color: "red",
                        });
                    }
                });

                props.links.forEach((item: any) => {
                    const { searchKeyword, keyword, cnt } = item;

                    if (!nodeMap.has(keyword)) {
                        nodeMap.set(keyword, {
                            name: keyword,
                            value: 0,
                            color: "blue",
                        });
                    }

                    // 등장 빈도 누적 (선택)
                    nodeMap.get(searchKeyword).value += cnt;
                    nodeMap.get(keyword).value += cnt;
                });

                const data = Array.from(nodeMap.values());
                chartData.value = setCoOccurrenceData(data, links);
            };

            return {
                props,
                chartLayout,
                numberFormat,
                chartData,
                chartDateFormat2,
            };
        },
    };
</script>
